import React from "react";
import { Tooltip } from 'antd';
import moment from 'moment';
import { dollarText, pricePerUnitText, replaceSelect } from "../../../../../utils/replacer";
import {
  UnderlyingContent,
  PoolDataValue,
  PoolDataHeading
} from "./styles";
import { milliToDate } from '../../../../../utils/commonUtil';

export const columnsInto = [
  {
    title: () => {
      return <PoolDataValue>Investment options</PoolDataValue>;
    },
    render: record => {
      return <PoolDataHeading>{replaceSelect(record.poolName)}</PoolDataHeading>;
    },
    key: "poolName",
    width: "20%"
  },
  {
    title: () => {
      return <PoolDataValue>Available balance</PoolDataValue>;
    },
    render: record => {
      return <PoolDataHeading>{dollarText(record.availableBalance)}</PoolDataHeading>;
    },
    key: "availableBalance",
    width: "20%"
  },
  {
    title: () => {
      return <PoolDataValue>Price per unit</PoolDataValue>;
    },
    render: record => {
      const perUpdatedOn = 'Price updated on ' + moment(moment.tz(record.dateOfPricePerUnit, 'America/New_York')).format('MM/DD/YYYY')
      return (
        <Tooltip placement="bottomLeft" title={perUpdatedOn}>
          <UnderlyingContent>
            {pricePerUnitText(record.pricePerUnit, record.isRise)}
          </UnderlyingContent>
        </Tooltip>
      );
    },
    key: "pricePerUnit",
    width: "20%"
  },
  {
    title: () => {
      return <PoolDataValue>Dollars</PoolDataValue>;
    },
    render: record => {
      return <PoolDataHeading>{dollarText(record.value)}</PoolDataHeading>;
    },
    key: "pricePerUnit",
    width: "20%"
  }
];

export const columnsFrom = [
  {
    title: () => {
      return <PoolDataValue>Investment options</PoolDataValue>;
    },
    render: record => {
      return <PoolDataHeading>{replaceSelect(record.poolName)}</PoolDataHeading>;
    },
    key: "poolName",
    width: "20%"
  },
  {
    title: () => {
      return <PoolDataValue>Available balance</PoolDataValue>;
    },
    render: record => {
      return <PoolDataHeading>{dollarText(record.availableBalance)}</PoolDataHeading>;
    },
    key: "availableBalance",
    width: "20%"
  },
  {
    title: () => {
      return <PoolDataValue>Price per unit</PoolDataValue>;
    },
    render: record => {
      const perUpdatedOn = 'Price updated on ' + milliToDate(record.dateOfPricePerUnit);
      const perUpdatedAsOf = 'Price updated on ' + milliToDate(record.asOfDate);
      return (
        <Tooltip placement="bottomLeft" title={record.availableBalance ? perUpdatedOn : perUpdatedAsOf}>
          <UnderlyingContent>
            {pricePerUnitText(record.pricePerUnit, record.isRise)}
          </UnderlyingContent>
        </Tooltip>
      );
    },
    key: "pricePerUnit",
    width: "20%"
  },
  {
    title: () => {
      return <PoolDataValue>Percentage</PoolDataValue>;
    },
    render: record => {
      let per = Number(record.value).toFixed(2);
      return <PoolDataHeading>{per} %</PoolDataHeading>;
    },
    key: "pricePerUnit",
    width: "20%"
  }
];
